import { Button, CircularProgress, Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Html5Qrcode, Html5QrcodeScannerState } from "html5-qrcode";
import React, { useEffect, useRef, useState } from "react";

export default function QRScannerView({ show, setValue, exit }) {
  const [scanner, setScanner] = useState();
  const [scannedCode, setScannedCode] = useState("");
  const [details, setDetails] = useState();
  const [cameraId, setCameraId] = useState();
  const ref = useRef();
  const canvasarea = 500;

  const qrboxFunction = (viewfinderWidth, viewfinderHeight) => {
    let minEdgePercentage = 0.7; // 70%
    let minEdgeSize = Math.min(viewfinderWidth, viewfinderHeight);
    let qrboxSize = Math.floor(minEdgeSize * minEdgePercentage);
    return {
      width: qrboxSize,
      height: qrboxSize,
    };
  };

  const readSuccess = (e, f) => {
    if (f && f.decodedText) {
      setScannedCode(f.decodedText);
      setDetails(JSON.stringify(f.result.format));
    }
    if (!e || !e.data) {
      return;
    }
    setScannedCode(e.data);
  };

  useEffect(() => {
    const func = async () => {
      if (ref.current) {
        try {
          var devs = await Html5Qrcode.getCameras();
          var v;
          if (devs && devs.length) {
            v = new Html5Qrcode(ref.current.id);
            setCameraId(devs[0].id);
          }
          setScanner(v);
        } catch (error) {
          console.log(error);
        }
      }
    };
    func();
  }, [ref]);

  useEffect(() => {
    if (scannedCode && scanner) {
      scanner.pause();
    }
  }, [scannedCode, scanner]);

  const close = () => {
    try {
      if (scanner) {
        scanner.stop();
      }
    } catch (error) {}

    setScannedCode("");
    setValue(scannedCode);
    exit();
  };

  return show ? (
    <Grid container>
      <Grid item>
        {scanner && cameraId ? (
          <Button
            onClick={() => {
              try {
                scanner.start(cameraId, { qrbox: qrboxFunction }, readSuccess);
              } catch (error) {
                try {
                  scanner.resume();
                } catch (error) {}
              }
            }}
            variant="outlined"
          >
            {scanner.getState() === Html5QrcodeScannerState.PAUSED
              ? "Rescan"
              : "Scan Barcode or QRCode with camera"}
          </Button>
        ) : (
          <CircularProgress />
        )}
      </Grid>
      <Grid item xs={12}>
        <div
          ref={ref}
          id={"qr-canvasdsafasdfasdfdasfsd"}
          style={{ width: canvasarea }}
        ></div>
      </Grid>
      <Grid item xs={12}>
        {scannedCode ? (
          <Typography>Scanned Code {scannedCode}</Typography>
        ) : null}
        {details && <Typography>Details {details}</Typography>}
      </Grid>
      <Grid item xs={12}>
        <Button variant="outlined" onClick={close}>
          OK
        </Button>
      </Grid>
    </Grid>
  ) : null;
}
